import { useContext } from 'react';
import { TodoContext } from '../context/DataProvider';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import { CircularProgress,
		Typography,
		Container,
		TextField,
		Backdrop,
		Button,
		Paper,
		Box } from '@mui/material';
import { useFormik } from "formik";
import { useBasicComponentStates } from "../repositories/utils";

import * as Yup from "yup";

function Login() {

	const { fireBaseLogin } = useContext(TodoContext);

	const navigate = useNavigate();

    const {
        loading: mainViewLoading, setLoading: mainViewSetLoading,
        hasLoaded: mainViewHasLoaded, setHasLoaded: mainViewSetHasLoaded
    } = useBasicComponentStates({editingForm: false});

	const getFirebaseAuthErrorMessage = (code) => {
		switch (code) {
			case "auth/user-not-found":
				return "El usuario no existe.";
			case "auth/invalid-email":
				return "Correo inválido.";
			case "auth/invalid-login-credentials":
				return "usuario y/o contraseña incorrectos";
			case "auth/too-many-requests":
				return "Demasiados intentos. Intenta más tarde.";
			case "auth/network-request-failed":
				return "Error de conexión.";
			default:
				return "No se pudo iniciar sesión.";
		}
	};

	const formik = useFormik({
		initialValues: {
			usuario: "",
			password: ""
		},
		validateOnBlur: false,
		validateOnChange: false,
		validationSchema: Yup.object().shape({
			usuario: Yup.string().required("Es Requerido un nombre de usuario."),
			password: Yup.string().required("Favor de ingresar contraseña.")
		}),
		onSubmit: async (values) => {
			mainViewSetLoading(true);

			try {
				const resp = await fireBaseLogin(formik.values.usuario.trim(), formik.values.password.trim());

				if(resp && resp.status == "ok")
				{
					navigate("/");
				}else{
					const message = getFirebaseAuthErrorMessage(resp.errorCode);
					toast.error(message, { position: "bottom-center" });
					mainViewSetLoading(false);
				}
			} catch (error) {
				toast.error(error.message, { position: "bottom-center" });
				mainViewSetLoading(false);
			};
		},
	});

	const handleBlur = (field) => {
		formik.setFieldTouched(field, true, true);
	};

	return (
		<Container component="main" maxWidth="xs">
			<Paper elevation={3} style={{ padding: '2rem', marginTop: '2rem' }}>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
					}}
				>
					<Typography component="h1" variant="h5">
						Iniciar Sesión
					</Typography>

					<Box sx={{ mt: 1 }}>
						<TextField
							required
							fullWidth
							autoFocus
							id="usuario"
							name="usuario"
							margin="normal"
							label="Nombre de Usuario"
                            value={formik.values.usuario}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.usuario)}
                            helperText={formik.errors.usuario}
                            onBlur={() => handleBlur("usuario")}
						/>

						<TextField
							required
							fullWidth
							id="password"
							name="password"
							margin="normal"
							label="Contraseña"
							type="password"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.password)}
                            helperText={formik.errors.password}
                            onBlur={() => handleBlur("password")}
						/>

						<Button
							type="submit"
							fullWidth
							variant="contained"
							sx={{ mt: 3, mb: 2 }}
							onClick={() => formik.handleSubmit()}
						>
							Entrar
						</Button>
					</Box>
				</Box>
			</Paper>

            <Backdrop
                sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
                open={mainViewLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
			<ToastContainer/>
		</Container>
	);
}

export default Login;